import styled, { keyframes } from 'styled-components';
import { lFColor, lFColor2 } from 'pages/components/LFHeader/LFHeader.styled';
import { overlayScrimHeavy } from 'pages/styles';
import { overlayZIndex } from '../Modal/Modal.styled';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

/** Full-bleed overlay; layout alerts sit above this in z (no Y gap). */
export const Root = styled.div<{ $instant?: boolean }>`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100svh;
  z-index: ${overlayZIndex + 100};
  pointer-events: auto;
  /* Always soft-fade — $instant used to hard-cut a dark screen (felt like a black flash). */
  animation: ${fadeIn} ${({ $instant }) => ($instant ? '0.08s' : '0.15s')} ease-out;
`;

export const Bg = styled.div<{ isSticky?: boolean }>`
  position: absolute;
  inset: 0;
  background: ${overlayScrimHeavy};
`;

export const Progress = styled.div<{ $inPage?: boolean, $compact?: boolean }>`
  position: ${({ $compact }) => ($compact ? 'relative' : 'absolute')};
  z-index: 1;
  left: ${({ $compact }) => ($compact ? 'auto' : '50%')};
  top: ${({ $compact }) => ($compact ? 'auto' : '50%')};
  transform: ${({ $compact }) => ($compact ? 'none' : 'translate(-50%, -50%)')};
  display: flex;
  flex-direction: ${({ $compact }) => ($compact ? 'row' : 'column')};
  align-items: center;
  gap: ${({ $compact }) => ($compact ? '8px' : '14px')};
  min-width: ${({ $compact }) => ($compact ? '0' : '120px')};
  padding: ${({ $compact }) => ($compact ? '0' : '22px 28px')};
  border-radius: 14px;
  background: ${({ $compact }) => ($compact ? 'transparent' : '#fff')};
  color: ${lFColor};
  box-shadow: ${({ $inPage, $compact }) => (
    $compact || $inPage ? 'none' : '0 12px 40px rgba(33, 33, 55, 0.18)'
  )};
  border: ${({ $inPage, $compact }) => (
    $compact ? 'none' : $inPage ? '1px solid rgba(33, 33, 55, 0.12)' : 'none'
  )};
`;

export const SpinnerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${lFColor};
`;

/** Border spinner: rotate-only (composited), fixed stroke — avoids MUI dash-array jank/thinning. */
export const Spinner = styled.div<{ $compact?: boolean }>`
  box-sizing: border-box;
  width: ${({ $compact }) => ($compact ? '22px' : '36px')};
  height: ${({ $compact }) => ($compact ? '22px' : '36px')};
  border-radius: 50%;
  border: ${({ $compact }) => ($compact ? '3px' : '4px')} solid rgba(33, 33, 55, 0.14);
  border-top-color: currentColor;
  animation: ${spin} 0.75s linear infinite;
  will-change: transform;
`;

export const Message = styled.div<{ $compact?: boolean }>`
  font-family: Poppins, sans-serif;
  font-size: ${({ $compact }) => ($compact ? '12px' : '13px')};
  font-weight: 500;
  letter-spacing: 0.01em;
  color: ${lFColor2};
  text-align: ${({ $compact }) => ($compact ? 'left' : 'center')};
  max-width: ${({ $compact }) => ($compact ? 'none' : '200px')};
  line-height: 1.35;
  white-space: ${({ $compact }) => ($compact ? 'nowrap' : 'normal')};
`;
